<div [froalaView]="component?.systemDocument?.content"
     [style.height.px]="documentHeight"
     class="border border-1"></div>
